
export const themeAttributeName = 'score-theme';
const initialTheme = 'red';
if (document.documentElement.getAttribute(themeAttributeName) === null) {
    document.documentElement.setAttribute(themeAttributeName, initialTheme);
}

export const setTheme = function (theme) {
    document.documentElement.setAttribute(themeAttributeName, theme);
}

